import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { FormDirectivesAngularModule } from 'rev-shared/util/directives/form/FormDirectivesAngular.Module';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { PipesAngularModule } from 'rev-shared/pipes/Pipes.AngularModule';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { TextInputAngularModule } from 'rev-shared/ui/text-input/TextInputAngular.Module';
import { VbDropdownMenuModule } from 'rev-shared/ui/dropdown-menu/VbDropdownMenu.Module';
import { VbProfilePictureModule } from 'rev-shared/ui/profile/VbProfilePicture.Module';
import { VbTextAreaModule } from 'rev-shared/ui/textArea/VbTextArea.Module';
import { VbUiHtmlEditorComponent } from 'rev-shared/htmlEditor/VbUiHtmlEditor.Component';

import { BrandingAngularModule } from 'rev-portal/branding/BrandingAngular.Module';
import { ScheduledEventsCommonModule } from 'rev-portal/scheduledEvents/common/ScheduledEventsCommon.AngularModule';
import { WebcastSharedComponentsModule } from 'rev-portal/scheduledEvents/webcast/sharedComponents/WebcastSharedComponents.Module';

import { VbWebcastChatSidebarComponent } from './VbWebcastChatSidebar.Component';

const components = [
	VbWebcastChatSidebarComponent,
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		BrandingAngularModule,
		BsDropdownModule,
		ButtonsAngularModule,
		CommonModule,
		DateAngularModule,
		DirectivesAngularModule,
		FormDirectivesAngularModule,
		FormGroupAngularModule,
		FormsModule,
		VbUiHtmlEditorComponent,
		PipesAngularModule,
		ScheduledEventsCommonModule,
		SpinnerAngularModule,
		TextInputAngularModule,
		TooltipModule,
		TranslateModule,
		VbDropdownMenuModule,
		VbProfilePictureModule,
		VbTextAreaModule,
		WebcastSharedComponentsModule
	]
})
export class WebcastChatModule {}
